
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */
import { css } from '@emotion/css';
import {
  Color,
  Content,
  Margin,
  Size,
  Title,
  Padding,
  Text,
  Flex,
  FlexItem,
  FlexSpacer,
  Direction,
  Speed,
  AnimatedItem,
  AnimationGroup,
  EmptyState,
  Breadcrumbs,
  Shade,
  Button,
  Category,
  Avatar,
  Icon,
} from '@drawbotics/react-drylus';
import Playground from '~/components/Playground';
import { Navbar } from './components/Navbar';


const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


<h1>{`Toolbar example`}</h1>
<Playground __position={0} __code={`<>
  <Navbar />
  <Content>
    <Padding>
      <Breadcrumbs
        crumbs={[
          {
            icon: 'home',
          },
          {
            label: 'Project',
          },
          {
            label: 'Dashboard',
            active: true,
          },
        ]}
      />
      <Margin size={{ top: Size.DEFAULT, bottom: Size.EXTRA_LARGE }}>
        <Flex animated animationDirection={Direction.TOP_DOWN} animationSpeed={Speed.FAST}>
          <FlexItem>
            <Title size={4} noMargin>
              Dashboard
            </Title>
          </FlexItem>
          <FlexSpacer size={Size.SMALL} />
          <FlexItem>
            <Text shade={Shade.MEDIUM} size={Size.SMALL}>
              The last 3 months
            </Text>
          </FlexItem>
          <FlexSpacer flex size={Size.SMALL} />
          <FlexItem>
            <Button category={Category.BRAND}>Invite teammates</Button>
          </FlexItem>
          <FlexSpacer size={Size.SMALL} />
          <FlexItem>
            <Flex animated animationDelay={400} animationDirection={Direction.RIGHT_LEFT} animationSpeed={Speed.FAST}>
              <FlexItem style={{ position: 'relative', zIndex: 4 }}>
                <Avatar text="M" color={Color.ORANGE} />
              </FlexItem>
              <FlexItem style={{ position: 'relative', zIndex: 3 }}>
                <Avatar style={{ marginLeft: -10 }} text="L" color={Color.BLUE} />
              </FlexItem>
              <FlexItem style={{ position: 'relative', zIndex: 2 }}>
                <Avatar style={{ marginLeft: -10 }} text="F" color={Color.GREEN} />
              </FlexItem>
              <FlexItem style={{ position: 'relative', zIndex: 1 }}>
                <Button size={Size.SMALL} style={{ marginLeft: -10 }} leading={<Icon name="plus" />} />
              </FlexItem>
            </Flex>
          </FlexItem>
        </Flex>
      </Margin>
      <AnimatedItem delay={1200}>
        <EmptyState />
      </AnimatedItem>
    </Padding>
  </Content>
</>`} mode="jsx" mdxType="Playground">
  <>
    <Navbar mdxType="Navbar" />
    <Content mdxType="Content">
      <Padding mdxType="Padding">
        <Breadcrumbs crumbs={[{
              icon: 'home'
            }, {
              label: 'Project'
            }, {
              label: 'Dashboard',
              active: true
            }]} mdxType="Breadcrumbs" />
        <Margin size={{
              top: Size.DEFAULT,
              bottom: Size.EXTRA_LARGE
            }} mdxType="Margin">
          <Flex animated animationDirection={Direction.TOP_DOWN} animationSpeed={Speed.FAST} mdxType="Flex">
            <FlexItem mdxType="FlexItem">
              <Title size={4} noMargin mdxType="Title">
                Dashboard
              </Title>
            </FlexItem>
            <FlexSpacer size={Size.SMALL} mdxType="FlexSpacer" />
            <FlexItem mdxType="FlexItem">
              <Text shade={Shade.MEDIUM} size={Size.SMALL} mdxType="Text">
                The last 3 months
              </Text>
            </FlexItem>
            <FlexSpacer flex size={Size.SMALL} mdxType="FlexSpacer" />
            <FlexItem mdxType="FlexItem">
              <Button category={Category.BRAND} mdxType="Button">Invite teammates</Button>
            </FlexItem>
            <FlexSpacer size={Size.SMALL} mdxType="FlexSpacer" />
            <FlexItem mdxType="FlexItem">
              <Flex animated animationDelay={400} animationDirection={Direction.RIGHT_LEFT} animationSpeed={Speed.FAST} mdxType="Flex">
                <FlexItem style={{
                      position: 'relative',
                      zIndex: 4
                    }} mdxType="FlexItem">
                  <Avatar text="M" color={Color.ORANGE} mdxType="Avatar" />
                </FlexItem>
                <FlexItem style={{
                      position: 'relative',
                      zIndex: 3
                    }} mdxType="FlexItem">
                  <Avatar style={{
                        marginLeft: -10
                      }} text="L" color={Color.BLUE} mdxType="Avatar" />
                </FlexItem>
                <FlexItem style={{
                      position: 'relative',
                      zIndex: 2
                    }} mdxType="FlexItem">
                  <Avatar style={{
                        marginLeft: -10
                      }} text="F" color={Color.GREEN} mdxType="Avatar" />
                </FlexItem>
                <FlexItem style={{
                      position: 'relative',
                      zIndex: 1
                    }} mdxType="FlexItem">
                  <Button size={Size.SMALL} style={{
                        marginLeft: -10
                      }} leading={<Icon name="plus" mdxType="Icon" />} mdxType="Button" />
                </FlexItem>
              </Flex>
            </FlexItem>
          </Flex>
        </Margin>
        <AnimatedItem delay={1200} mdxType="AnimatedItem">
          <EmptyState mdxType="EmptyState" />
        </AnimatedItem>
      </Padding>
    </Content>
  </>
</Playground>
    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;